"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALES_FLAG = exports.LOCALES = void 0;
var _LanguageEnum = require("./LanguageEnum");
/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2023-02-01 14:55:19
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2023-03-17 11:42:36
 */

const LOCALES = exports.LOCALES = {
  [_LanguageEnum.Languages.EN_US]: require("../locales/en_US.json"),
  [_LanguageEnum.Languages.PT_BR]: require("../locales/pt_BR.json"),
  [_LanguageEnum.Languages.ES_MX]: require("../locales/es_MX.json")
};
const LOCALES_FLAG = exports.LOCALES_FLAG = {
  "🇺🇸(US)": _LanguageEnum.Languages.EN_US,
  "🇧🇷(BR)": _LanguageEnum.Languages.PT_BR,
  "🇲🇽(ES)": _LanguageEnum.Languages.ES_MX
};